var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberFour = function SvgIconNumberFour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.568 2.583a1 1 0 0 0-1.886-.666l-4.5 12.75A1 1 0 0 0 7.125 16h8v5a1 1 0 1 0 2 0V9a1 1 0 1 0-2 0v5H8.538z"
  })));
};
export default SvgIconNumberFour;